import {ECallLogTypes} from "../context/types";
export const getLogCaptionByType = (firstName, type) => {
  switch (type) {
    case ECallLogTypes.PARTICIPANT_JOIN:
      return `${firstName} joined`;
    case ECallLogTypes.PARTICIPANT_DISCONNECT:
      return `${firstName} left`;
    case ECallLogTypes.PARTICIPANT_IN_PROGRESS:
      return `${firstName} is in progress`;
    case ECallLogTypes.CONNECT_ERROR:
      return `${firstName} has connection error`;
    default:
      return;
  }
};
